enum GeneralEvents {
  SESSION_ERROR = 'sessionError',
}

export default GeneralEvents
